import * as Types from '../generated/webapp_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ArchivedSurveyTemplatesQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['Int']['input'];
  sort?: Types.InputMaybe<Types.SortByCreatedAtInput>;
}>;


export type ArchivedSurveyTemplatesQuery = { __typename?: 'Query', employee?: { __typename?: 'Employee', id: number, archivedSurveyTemplatesCollection?: { __typename?: 'SurveyTemplateCollection', total?: number | null, items?: Array<{ __typename?: 'SurveyTemplate', id: string, title: string, latestSendDate?: any | null } | null> | null } | null } | null };


export const ArchivedSurveyTemplatesDocument = gql`
    query ArchivedSurveyTemplates($employeeId: Int!, $sort: SortByCreatedAtInput) {
  employee(id: $employeeId) {
    id
    archivedSurveyTemplatesCollection(sort: $sort) {
      items {
        id
        title
        latestSendDate
      }
      total
    }
  }
}
    `;

/**
 * __useArchivedSurveyTemplatesQuery__
 *
 * To run a query within a React component, call `useArchivedSurveyTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedSurveyTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedSurveyTemplatesQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useArchivedSurveyTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ArchivedSurveyTemplatesQuery, ArchivedSurveyTemplatesQueryVariables> & ({ variables: ArchivedSurveyTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchivedSurveyTemplatesQuery, ArchivedSurveyTemplatesQueryVariables>(ArchivedSurveyTemplatesDocument, options);
      }
export function useArchivedSurveyTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchivedSurveyTemplatesQuery, ArchivedSurveyTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchivedSurveyTemplatesQuery, ArchivedSurveyTemplatesQueryVariables>(ArchivedSurveyTemplatesDocument, options);
        }
export function useArchivedSurveyTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ArchivedSurveyTemplatesQuery, ArchivedSurveyTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArchivedSurveyTemplatesQuery, ArchivedSurveyTemplatesQueryVariables>(ArchivedSurveyTemplatesDocument, options);
        }
export type ArchivedSurveyTemplatesQueryHookResult = ReturnType<typeof useArchivedSurveyTemplatesQuery>;
export type ArchivedSurveyTemplatesLazyQueryHookResult = ReturnType<typeof useArchivedSurveyTemplatesLazyQuery>;
export type ArchivedSurveyTemplatesSuspenseQueryHookResult = ReturnType<typeof useArchivedSurveyTemplatesSuspenseQuery>;
export type ArchivedSurveyTemplatesQueryResult = Apollo.QueryResult<ArchivedSurveyTemplatesQuery, ArchivedSurveyTemplatesQueryVariables>;